import { defaultComponents as selectMenuDefaultComponents } from 'bold-ui/lib/components/Select/SelectSingle/SelectDownshiftMenu'
import React from 'react'

import {
  MaisItensSelectMenuItem,
  MaisItensSelectMenuItemProps,
} from '../../MaisItensSelectMenuItem/MaisItensSelectMenuItem'
import { LotacaoAgendaSelectGrupoCabecalho } from '../cabecalho/LotacaoAgendaSelectGrupoCabecalho'
import {
  isTipoGrupoCabecalho,
  isTipoGrupoVazio,
  LotacaoAgendaSelectFieldItemProps,
} from '../model-lotacaoAgendaSelectField'
import { LotacaoAgendaSelectGrupoVazioItem } from './LotacaoAgendaSelectGrupoVazioItem'

interface LotacaoAgendaSelectComAcessoRapidoItemProps
  extends LotacaoAgendaSelectFieldItemProps,
    MaisItensSelectMenuItemProps {}

export function LotacaoAgendaSelectComAcessoRapidoItem(props: LotacaoAgendaSelectComAcessoRapidoItemProps) {
  const { index, selectMaxItems: selectSize, ...rest } = props

  const {
    downshift: { getItemProps },
    item,
    renderItem,
  } = rest

  if (isTipoGrupoCabecalho(item)) {
    return <LotacaoAgendaSelectGrupoCabecalho grupoTipo={item} />
  }

  if (isTipoGrupoVazio(item)) {
    return <LotacaoAgendaSelectGrupoVazioItem grupoTipo={item} />
  }

  return index < selectSize ? (
    <selectMenuDefaultComponents.Item index={index} {...rest}>
      {renderItem(item)}
    </selectMenuDefaultComponents.Item>
  ) : (
    <MaisItensSelectMenuItem {...getItemProps({ item, index })} selectMaxItems={selectSize} />
  )
}
